import { render, staticRenderFns } from "./ResidentialBoardingHouseMultiTenant.vue?vue&type=template&id=c650b964&scoped=true&"
import script from "./ResidentialBoardingHouseMultiTenant.vue?vue&type=script&lang=ts&"
export * from "./ResidentialBoardingHouseMultiTenant.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialBoardingHouseMultiTenant.vue?vue&type=style&index=0&id=c650b964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c650b964",
  null
  
)

export default component.exports